/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Total_PeriodInputs */



/**
* | output |
* | --- |
* | "Total Period" |
*
* @param {Dashboard_Total_PeriodInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const dashboard_total_period = /** @type {((inputs?: Dashboard_Total_PeriodInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Total_PeriodInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Gesamtzeitraum")
	return /** @type {LocalizedString} */ ("Total Period")
});